import { render, staticRenderFns } from "./ModelGoalsPanel.vue?vue&type=template&id=8775c092"
import script from "./ModelGoalsPanel.vue?vue&type=script&lang=js"
export * from "./ModelGoalsPanel.vue?vue&type=script&lang=js"
import style0 from "./ModelGoalsPanel.vue?vue&type=style&index=0&id=8775c092&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports